// extracted by mini-css-extract-plugin
module.exports = {"checkout-list":"CheckoutList_checkout-list__255MC","row":"CheckoutList_row__XDOcR","subtotal":"CheckoutList_subtotal__3nQ3_","total":"CheckoutList_total__1_AUq"};